import { createGlobalStyle } from 'styled-components';
import { getColor, StyleVars } from "core/utils/Styles";

const PaginationStyles = createGlobalStyle`
	/* the CSS below is modified from bootstrap */
	/* stylelint-disable no-descending-specificity */
	.reactPagination {
		display: flex;
		justify-content: center;
		flex-wrap: wrap;
		padding-left: 0;

		> li {
			display: inline;
			margin-left: 8px;

			> a,
			> div {
				position: relative;
				float: left;
				height: 32px;
				width: 32px;
				line-height: 32px;
				text-decoration: none;
				font-weight: 600;
				color: ${getColor("mutedGray")};
				background-color: ${getColor("white")};
				border: 1px solid ${getColor("gray1")};
				border-radius: 4px;
				text-align: center;
				cursor: pointer;

				/* adjusting the width of the box around the page number */
				@media (max-width: 320px) {
					width: 28px;
				}
			}

			&:first-child {
				/* get rid of margin for Previous button */
				margin-left: 0;

				> a {
					margin-left: 0;
					border-radius: ${StyleVars.defaultBorderRadius};
					width: 100%;
					padding: 0 11px;
				}

				&.disabled {
					display: none;
				}
			}

			&:last-child {
				> a {
					border-radius: ${StyleVars.defaultBorderRadius};
					width: 100%;
					padding: 0 11px;
				}

				&.disabled {
					display: none;
				}
			}
		}

		> li > a,
		> li > span {
			&:hover,
			&:focus {
				outline-color: ${getColor("primaryBrand")};
			}

			&:hover {
				color: ${getColor("white")};
				background-color: ${getColor("primaryBrand")};
				transition: background ease-in-out 0.15s, color ease-in-out 0.15s;
			}
		}

		> .active > a,
		> .active > span {
			&,
			&:hover,
			&:focus {
				z-index: 2;
				color: ${getColor("white")};
				background-color: ${getColor("primaryBrand")};
				border-color: ${getColor("primaryBrand")};
				outline-color: ${getColor("primaryBrand")};
			}
		}

		> .disabled {
			> span,
			> a,
			> a:hover,
			> a:focus {
				color: ${getColor("mutedGray")};
				background-color: ${getColor("white")};
				border-color: ${getColor("gray1")};
				cursor: not-allowed;
			}
		}

		/* get rid of margin for ellipsis and the element right after the ellipsis */
		.break, .break + li {
			margin-left: 0;
		}
		/* stylelint-enable */
	}
`;

export default PaginationStyles;
